/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';
import { InputSizesType, InputVariantType } from '../ThemeProvider/types';

const PatternUnderline = css`
  left: -1px;
  top: 23px;
`;

const PatternContainedLabel = css`
  left: 16px;
  top: 27px;
`;

const PatternTopAlignedLabelSmall = css`
  left: 16px;
  top: 39.5px;
`;

const PatternTopAlignedLabelDefault = css`
  left: 16px;
  top: 42.5px;
`;

export const TimeInputContainer = styled.div`
  position: relative;
`;

export const InputPattern = styled.div<{
  size: InputSizesType;
  variant: InputVariantType;
  hasError: boolean;
}>`
  position: absolute;
  text-align: right;
  font-family: 'Mulish', sans-serif;
  letter-spacing: 2px;
  color: ${({ theme, hasError }) => (hasError ? theme.status.error.color : theme.gray80)};
  font-size: ${({ theme, size }) => theme.input.sizes[size].fontSize}px;
  width: ${({ size }) => (size === 'standard' ? 45 : 41)}px;

  ${({ variant, size }) =>
    variant === 'underline'
      ? PatternUnderline
      : variant === 'contained-label'
      ? PatternContainedLabel
      : size === 'small'
      ? PatternTopAlignedLabelSmall
      : PatternTopAlignedLabelDefault}
`;

export const UnitText = styled.p<{ size: InputSizesType; hasError: boolean; disabled: boolean }>`
  color: ${({ theme, hasError, disabled }) =>
    hasError ? theme.status.error.color : disabled ? theme.grayB8 : theme.gray80};
  font-weight: 400;
  line-height: ${({ theme, size }) => theme.input.sizes[size].lineHeight}px;
  font-size: ${({ theme, size }) => theme.input.sizes[size].fontSize}px;
  padding-bottom: 0;
`;
